// The page's one tile renderer: its display list is also what tools, docks and the keyboard hit-test against.
import { TileRenderer } from './tiles';
import { useDesign } from '../state';

export const renderer = new TileRenderer();

/** The display list for the current document. The canvas updates it once per frame; input that arrives
 *  before that frame (a click right after Ctrl+G) must not see the previous document. */
export function currentList() {
  const doc = useDesign.getState().doc;
  if (doc) renderer.setDoc(doc);
  return renderer.list;
}
